import React from "react";

const Privacy = () => {
  return (
    <div className="privacy-container">
      {/* Header */}
      <div className="privacy-header">
        <h1>Privacy Policy</h1>
      </div>

      {/* Content */}
      <div className="privacy-content">
        <h5>Privacy Policy - Pharma Tuition App</h5>
        <p>
          <strong>Effective Date:</strong> 07/04/2026
        </p>

        <p>
          Pharma Tuition ("we", "our", "us") values your privacy. This Privacy
          Policy explains how we collect, use, and protect your information when
          you use our mobile application.
        </p>

        <h3>1. Information We Collect</h3>
        <p>We may collect:</p>
        <ul>
          <li>Personal Information (Name, Email, Phone number)</li>
          <li>Usage Data (App interactions, logs)</li>
          <li>Device Information (Device type, OS version)</li>
        </ul>

        <h3>2. How We Use Information</h3>
        <p>We use your data to:</p>
        <ul>
          <li>Provide and improve our services</li>
          <li>Personalize user experience</li>
          <li>Communicate updates and support</li>
        </ul>

        <h3>3. Data Sharing</h3>
        <p>We do not sell your personal data. We may share data with:</p>
        <ul>
          <li>Service providers (for app functionality)</li>
          <li>Legal authorities (if required by law)</li>
        </ul>

        <h3>4. Data Security</h3>
        <p>
          We take appropriate measures to protect your data but cannot guarantee
          100% security.
        </p>

        <h3>5. Children's Privacy</h3>
        <p>Our app is not intended for children under 13.</p>

        <h3>6. Changes to Policy</h3>
        <p>We may update this policy from time to time.</p>

        <h3>7. Contact Us</h3>
        <p>
          If you have questions, contact us at:
          <h6>📧 Email: info@pharmatuition.in </h6>
          <h6>📞 Call: +91 99741 33919</h6>
        </p>

        <h3>8. For Account Deletion</h3>
        <p>
          If you want to delete your account or remove your personal data,
          please contact us at:
          <h6>📧 Email: info@pharmatuition.in </h6>
          <h6>📞 Call: +91 99741 33919</h6>
          
        </p>
      </div>
    </div>
  );
};

export default Privacy;
